import React from 'react';

import PropTypes from 'prop-types';

import localize from 'wanderu-i18n/src/localize';

import placeGuideConfig from '../../../../config/placeguide.locale';
import QuickviewComponent from '../../Quickview/Quickview';

const STATS = [
    // view order
    'numberOfRoutes',
    'tripsPerDay',
    'cities',
    'carrierCount',
    'numberOfStations',
    'connectingRoutes',
    'countryCount',
    'cityCount',
    'routeCount',
];

const I18N_KEYS = {
    numberOfRoutes: 'routes',
    carrierCount: 'carriers',
    numberOfStations: 'numberOfStations',
    tripsPerDay: 'tripsPerDay',
    numberOfCities: 'cities',
    connectingRoutes: 'connectingRoutes',
    countryCount: 'countries',
    cityCount: 'cities',
    routeCount: 'routes',
};

const MINIMUM_METRICS = 2;

function Quickview(props) {
    const {
        t,
        className,
        quickviewData,
    } = props;

    const metrics = quickviewData
        .sort((m1, m2) => {
            return STATS.indexOf(m1.name) - STATS.indexOf(m2.name);
        })
        .reduce((metrics, metric) => {
            if (I18N_KEYS[metric.name]) {
                metrics.push({ ...metric, name: t(I18N_KEYS[metric.name]) });
            }
            return metrics;
        }, []);

    if (metrics.length < MINIMUM_METRICS) {
        return null;
    }

    return (
        <QuickviewComponent
            className={className}
            metrics={metrics}
            subtitle={t('routeSubtitle')}
            title={t('routeQuickFacts')}
        />
    );
}

Quickview.propTypes = {
    className: PropTypes.string,
    quickviewData: PropTypes.arrayOf(PropTypes.object).isRequired,
};

Quickview.defaultProps = {
    className: '',
};

export {
    Quickview,
};
export default localize(Quickview, ['t'], placeGuideConfig.namespace);
